(() => {
  const STORAGE_KEY = 'baeupCookieConsentAnswered';
  const COOKIE_NAME = 'baeup_cookie_consent_answered';
  const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
  const FINAL_ACTION_SELECTOR = [
    '#shopify-pc__banner__btn-accept',
    '#shopify-pc__banner__btn-decline',
    '#shopify-pc__prefs__header-accept',
    '#shopify-pc__prefs__header-decline',
    '#shopify-pc__prefs__header-save',
  ].join(',');
  const DIALOG_SELECTOR = '#shopify-pc__banner, #shopify-pc__prefs__dialog';

  function getStoredValue() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function setStoredValue() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      // Cookies still cover browsers where localStorage is unavailable.
    }

    document.cookie = `${COOKIE_NAME}=true; max-age=${ONE_YEAR_SECONDS}; path=/; SameSite=Lax`;
  }

  function hasCookieValue() {
    return document.cookie.split('; ').some((cookie) => cookie === `${COOKIE_NAME}=true`);
  }

  function hasAnswered() {
    return getStoredValue() === 'true' || hasCookieValue();
  }

  function hideCookieDialogs() {
    if (!hasAnswered()) return;

    document.querySelectorAll(DIALOG_SELECTOR).forEach((dialog) => {
      dialog.setAttribute('aria-hidden', 'true');
      dialog.style.setProperty('display', 'none', 'important');
    });
  }

  function rememberChoiceAndHideSoon() {
    setStoredValue();
    window.setTimeout(hideCookieDialogs, 0);
    window.setTimeout(hideCookieDialogs, 250);
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest(FINAL_ACTION_SELECTOR)) return;
      rememberChoiceAndHideSoon();
    },
    true
  );

  hideCookieDialogs();

  const observer = new MutationObserver(hideCookieDialogs);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
